module.exports = __webpack_public_path__ + "static/media/tick.5d10c039.svg";